import QRCode from "qrcode";

export const qrDataUrl = async (value, size = 240) => {
  if (!value) return "";
  return QRCode.toDataURL(String(value), {
    errorCorrectionLevel: "M",
    margin: 1,
    width: size,
    color: { dark: "#0b1f2a", light: "#ffffff" },
  });
};
